import { render, staticRenderFns } from "./CheckinFaq.vue?vue&type=template&id=4e5a6690"
import script from "./CheckinFaq.vue?vue&type=script&lang=js"
export * from "./CheckinFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports